import { Subject } from 'rxjs/Subject';
export var DraggableHelper = (function () {
    function DraggableHelper() {
        this.currentDrag = new Subject();
    }
    return DraggableHelper;
}());
//# sourceMappingURL=draggableHelper.provider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-draggable-droppable/dist/esm/src/draggableHelper.provider.js
// module id = 244
// module chunks = 4